import { BonusRuleResponse, BonusRule } from './@types/BonusRuleModel';

export class BonusRuleRepository {
    private httpService: IHttpService;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
    }
    async get(): Promise<BonusRule[]> {
        const response = await this.httpService.get<TKResponse<BonusRule[]>>('/bonus_rules');
        const getName = (item: BonusRule): string => (item as BonusRule).name ?? (item as BonusRule)?.name ?? '';
        const sort = response.data.sort((a, b) => getName(a).localeCompare(getName(b)));
        return sort.map((row: BonusRule) => ({ ...row, id: row.bonus_rule_id, break_rule: row.break_rule ? row.break_rule : undefined, paycode: row.paycode }));
    }
    async getById(id: number): Promise<BonusRuleResponse> {
        const response = await this.httpService.get<TKResponse<BonusRuleResponse>>(`/bonus_rules/${id}`);
        return response.data;
    }
    async create(data: Record<string, any>) {
        return await this.httpService.post('/bonus_rules', { data });
    }
    async update(id: number, data: Record<string, any>) {
        return await this.httpService.patch(`/bonus_rules/${id}`, { data });
    }
    async delete(id: number) {
        return await this.httpService.delete(`/bonus_rules/${id}`);
    }
}
